import { useSearchParams } from 'react-router'
import invariant from 'tiny-invariant'

export function useSearchParamOrFail(paramName: string) {
  const [searchParams] = useSearchParams()
  const param = searchParams.get(paramName)

  invariant(param, `Expected search param "${paramName}" to be defined`)

  return param
}
